export const en = {
  language: "English",
  home: {
    afaaq:"Afaq Private School",
    EducationalFeature:"Educational and pedagogical features",
    Kindergarten:"Kindergarten Department",
BasicSection:"Basic Section",
PostBasicection:"Post-Basic Section",
BilingualSection:"Bilingual Section",
addEmploye:"Add Employe",
selectnameEmployee:"select  Employe name",
editEmploye:"Edit Employe",
editpermissions:"Edit permissions",
region:"region name",

KindergartenContent:`
- A comprehensive curriculum that fosters educational and pedagogical development

- Distinctive learning based on modern educational approaches

- Diverse activities that cater to individual differences
- A safe and stimulating learning environment
- Development of values ​​and positive behavior
- Qualified and pedagogically competent teachers
- Attention to the child's psychological and social development

- Involvement of children in internal and external competitions and events
- Effective communication with parents
- Use of diverse and engaging tangible and digital teaching aids
- Partnerships with local community organizations
`,

    Effortless: "Effortless Student Attendance Tracking",
    Say: "Say goodbye to manual roll calls and paperwork. Our smart system helps schools track attendance, notify parents instantly, and generate insightful reports—all in one place.",
    GetStarted: "Get Started",
    QuickSummary: "Quick Summary",
    Summary: "Summary",
    TotalTeachers: "Total Teachers",
    TotalClasses: "Total Classes",
    TotalStudents: "Total Students",
    
    WeeklyAttendanceReport: "Weekly Attendance Report",
    
    AttendedAbsent: "Attended / Absent",
    
    Absent: "Absent",
    Attended: "Attended",
    TotalStudentsText: "Total Students",
    Welcome:"Welcome to",
    "ManageYourSchoolsEfficiently":"Manage Your Schools Efficiently",
"TotalSchools":"Total Schools",
    "ParentPhone": "Parent phone",
    "abouttitle": "Why Choose Our System?",
    aboutafaq:"About afaq",
    "aboutsubtitle": "Our system is simple and efficient—just 3 easy steps",
    "feature1title": "Automated Attendance Tracking",
    "feature1description": "Say goodbye to manual roll calls! Teachers can mark attendance with a single click, and absences are recorded instantly.",
    "feature2title": "Multi-User Access & Role-Based Permissions",
    "feature2description": "Designed for administrators and teachers, ensuring that everyone has the right level of access to the data they need.",
    "feature3title": "Cloud-Based & Secure",
    "feature3description": "Access the system from anywhere, on any device with full data encryption and secure cloud storage to protect student information.",
    "feature4title": "Customizable Attendance Policies",
    "feature4description": "Schools can define their own attendance rules, late policies, and absence thresholds, making the system adaptable to different educational institutions.",

    "howtitle": "How It Works? Step-by-Step Guide",
    "howdescription": "Our system is simple and efficient—just 3 easy steps",
    "step1Title": "Login In The System",
    "step1Description": "Teachers & students sign in securely from any device.",
    "step2Title": "Mark Attendance",
    "step2Description": "Easily track student attendance with a single click.",
    "step3Title": "Notify & Generate Reports",
    "step3Description":
      "Receive real-time updates, and schools get insightful attendance reports.",
    "contacttitle": "Contact Us",
    "contactsubtitle": "Any question or remarks? Just write us a message!",
    "contactInfo": "Contact Information",
    "phone": "Phone Number",
    "email": "Email",
    "ParentEmailAddress":"Parent Email address",
    "address":"address",
    signatureOnline: "signature Online",
Howcanweserveyou:"How can we serve you?",
    Wewelcome:"We welcome your inquiries, comments, and suggestions.",

    "location": "15 Tahrir Street, Downtown, Cairo, Egypt, 11511",
    "namePlaceholder": "Name",
    Registrationandtuitionfees:"Registration and tuition fees",
    governorates:"Governorates",
    "phonePlaceholder": "Phone Number",
    "messagePlaceholder": "Write your message...",
    "sendMessage": "Send Message",
    "Loading": "Loading.........",
    "reachUs": "Reach us",
    "quickLinks": "Quick Links",
    "home": "Home",
    "howItWorks": "How it works?",
    "contactUs": "Contact Us",
    "newsletterTitle": "Join Our Newsletter",
    "newsletterPlaceholder": "Your email address",
    "subscribe": "Subscribe",
    "newsletterNote": " We will send you weekly updates for better tool management.",
    "features": "Features",
    "login": "Login",
    "user": "User",
    "language": "English",
    "switchTo": "Arabic",
    "switchtoAccount":"switch to",    "Stage":"Stage",

    "welcome": "Welcome, Log into your account",
    "subtitle": "It is our great pleasure to have you on board!",
    "emailPlaceholder": "Email address",
    "passwordPlaceholder": " Password",
    "loggingIn": "Logging in...",
    "fillFields": "Please fill all fields",
    "invalidCredentials": "Invalid credentials, please try again.",
    "successMessage": "Logged in successfully!",
    "dashboard": "Dashboard",
    "schools": "Schools",
    "school": "School",
    "structure": "School Structure",
    "stages": "Stages",
    "grades": "Grades",
    "grade": "Grade",
"Notifications":"Notifications",
    send: "send",

    "subjects": "Subjects",
    "subject": "Subject",

    "teachers": "Teachers",
    "teacher": "Teacher",

    "classes": "Classes & Schedules",
    "addclass": "Add Class",
"MaxStudents":"Max Students",
"sessionnumber":"Sessions Number",
"Session":"Session",
"class": "Class",

    
"students": "Students",
"addStudents": "Add Students",
    


    "attendanceHistory": "Attendance History",
    "markAttendance": "Mark Attendance",
    "profile": "profile",
    "changePassword": "change Password",
    "logout": "Logout",
    "export": "Export",
    "schoolID": "school ID",
    "addschools": "add School",
    "Save":"Save",
    "SelectGender":"Select Gender",
    "gender":"Gender",

    "male":"Male",
    "female":"Female",
    "Oldpassword":"Current password",
    "Newpassword":"New password",
    "Confirmpassword":"Confirm password ",
    "SchoolStracture":"School Stracture",
    "addStage":"Add Stage",
    "add":"Add",
    "stageName":"Stage Name",
    "gradeName":"Grade Name",
    "ID":"ID",
    "AddGrades":"Add Grades",
    "SelectStage":"Select Stage",
    "addSubject":"Add Subject",
    "Semester":"Semester",
    "SelectGrades":"Select Grades",
    "SelectSemester":"Select Semester",
    "SelectSubject":"Select Subject",

    "secondsemester":"Second Semester",
    "firstsemster":"First Semester",
"addteachers":"Add Teachers",
"SelectTimeTable":"Select Time Table",
"SelectClass":"Select Class",
"SelectTeacher":"Select Teacher",
"Day":"Day",


 'monday': 'Monday',
 'tuesday': 'Tuesday',
 'wednesday': 'Wednesday',
 'thursday': 'Thursday',
 'friday': 'Friday',
 'saturday': 'Saturday',
 'sunday': 'Sunday',
 "Selectday":"Select day",
 "TodaysAttendance":"Today's Attendance",
"SelectSession":"Select Session",
"Selectyear":"Select Year",
"SelectMonth":"Select Month",
"SelectDays":"Select Days",
"Month":"Month",
"role":"Role",
mainexpenses:"Main expenses",
    visa:"Visa ",
        download:"Download",

forms:"Forms",

receipt:"Receipt",

"status":"Status",
"settings":"Settings",
"firstSection":"First Section",
"secondSection":"Second Section",
"thirdSection":"Third Section",

Academicyearexpenses:"Academic year expenses",
Academicyear:"Academic year",
    Cash:"Payment at the school ",
    Installments:"Installments ",
Lastpaymentdate:"Last payment date",
paymentdate:"payment date",

Preview:"Preview ",
    "successSuccessfully": "Added successfully",


title_en: "Title in English",
title_ar: "Title in Arabic",


description_en: "Description in English",
description_ar: "Description in Arabic",

image: "image",
UploadMainImage:"Upload Main Image",
Upload:"Upload",
ClickorDraganImage:"Click or Drag an Image",

files:"Files",
Transportation:"Transportation and housing data",

subtitle1_en: "Subtitle 1 in English",
subtitle_en: "Subtitle  in English",

subtitle_ar: "Subtitle  in Arabic",


subtitle2_en: "Subtitle 2 in English",
subtitle2_ar: "Subtitle 2 in Arabic",

subtitle3_en: "Subtitle 3 in English",
subtitle3_ar: "Subtitle 3 in Arabic",

subtitle4_en: "Subtitle 4 in English",
subtitle4_ar: "Subtitle 4 in Arabic",



subdescribtion1_en: "Sub-description 1 in English",
subdescribtion_en: "Sub-description  in English",
subdescribtion1_ar: "Sub-description 1 in Arabic",

subdescribtion2_en: "Sub-description 2 in English",
subdescribtion2_ar: "Sub-description 2 in Arabic",
subdescribtion_ar: "Sub-description  in Arabic",



subdescribtion3_en: "Sub-description 3 in English",
subdescribtion3_ar: "Sub-description 3 in Arabic",


subdescribtion4_en: "Sub-description 4 in English",
subdescribtion4_ar: "Sub-description 4 in Arabic",



"notfountTitle":"Page Not found",
"notfountParagraph1":"We are sorry, The page you requested could not be found",
"notfountParagraph2":"Please go back to the homepage",
"MarkAttendance":"Mark Attendance",
"areyousureyouwantdelet":"Are you sure you want to delete this?",
"areyousureyouwantreject":"Are you sure you want to reject this?",
"areyousureyouwantaccept":"Are you sure you want to accept this?",

    "resonOfreject": "Reason for rejection",
"expenses":"Expenses",
"income":"Income",
type:"Type",
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December",

"close":"Close",
"edit":"Edit",
"notmatch":"New password and confirm password do not match!",
"from":"From",
"to":"To",
"chooseStageFirst":"please choose stage first",
"chooseYearFirst":"please choose Year first",
"chooseMonthFirst":"please choose Month first",
ressonOfException:"reason Of Exception",
payNow:"pay Now",
RemainingPrice:"Remaining Price",
PaidPrice:"Paid Price",

"chooseGradeandSemsterirst":"choose Grade and Semester first",
"chooseGradefirst":"choose Grade first",
"chooseGrade":"choose Grade",
"Generaldata":"General data",
"Financialaccounting":"Financial accounting",
"Presenceandabsence":"Presence and absence",
"Teacherreserve":"Teacher reserve",
"ComingSoon":"Coming Soon",
"Addpermissions":"Add permissions",
"permissions":"Permissions",
"selectpermissions":"select permissions",
"AccountingandExpensesOfficer":"Accounting and Expenses Officer",
"Accountingemployee":"Accounting employee",
"Publicemployee":"Public employee",
"Financialofficer":"Financial officer",
"ProcurementOfficer":"Procurement Officer",
"PurchasingManager":"PurchasingManager",
"Salariesemployee":"Salaries employee",
"Maintenanceemployee":"Maintenance employee",
"Maintenancemanager":"Maintenance manager",
"Finance":"Finance",
"Purchases":"Purchases",
"Salaries":"Salaries",
"Maintenance":"Maintenance",
"Sales":"Sales (Student fees)",

"all":"all",
"Studyexpenses":"Tuition fees, exceptions, and study expenses",
"Exceptions":"Exceptions",
"FinancialDirector":"Financial Director",
"salesemployee":"sales (Student fees) employee",
"Purchasingemployee":"Purchasing employee",
"Administrators":"Administrators",
"Totalsales":"Total sales (Student fees)",
"price":"price",
    "nameStudent": "student Name",
        "nameEmployee": "Employee Name",


description: "Description",
"date":"Date",
"employee":"employee",
"employe":"employee",

"Totalmaintenanceprice":"Total maintenance price",
"Totalpurchasesprice":"Total purchases price",
"Total":"Total",

"tests":"Exam",
"statusStudent":"First grade in Primary, first semester",

"timeTable":"Time Table",
AllFinance:"All Finance",
section:"Section",
Purchasesprice:"Purchases price",
Salariesprice:"Salaries price",
Salary:"Salary",
Discounts:"Discounts",
Incentives:"Incentives",
Bonuses:"Bonuses",
Reasonfordiscount:"Reason for discount",
Reasonforrewards:"Reason for rewards",
Paid:"Paid",
unPaid:"unPaid",
addExceptions:"add Exceptions",
showExceptions:"show Exceptions",


method:"Method",
downloadpdf:"Download the registration pdf",
PreviewSignature:"Preview Signature",
RegistrationfileDone:"Registration file uploaded",

registrationconditions:"Registration conditions",
FeesSchedule:"Fees Schedule",
amount_paid:"The amount paid",

Iaccept:"I accept ",
theTermsConditions:"the Terms & Conditions",
reject:"Reject",
accept:"Accept",
identity_number:"Identity number",
rePay:"RePay",
Paycustomerdata:"Pay customer data",
signupasStudent:"signup as Student",
Pleasesendthereceipt:"Please send the receipt",
Pleasesendtheformfeetomyaccount:"Please send the form fee to my account",
bankAccount:"Via bank account",
Chooseapaymentmethod:"Choose a payment method",
Pleasepaytheregistrationformfee:"Please pay ",
currancy:"OMR",
Partnership:"Partnership with parents and the community",
Effectivecollaboration: '- Effective collaboration with families<br/>- Organizing joint events and activities<br/>- Partnerships with local community organizations',
registrationform:" registration form",
Tuitionfees:"Tuition fees",
acknowledge:"I acknowledge and agree to the registration and financial contract terms.",
Vision:"Vision",
pending:"pending",
  registrationTermsTitle: "Registration is done after reviewing all the registration details at the school, which are:",
  registrationTerms: [
    "1. All required documents for student registration must be attached.",
    "2. The parent is obligated to register the student on the educational portal. The administration will follow up on the registration process until it is completed.",
    "3. The registration document and the financial contract addendum must be signed together.",
    "4. The school has its own specific dates set by the Ministry of Education for the start of the school year, mid-term break, and end of the school year. Therefore, parents are requested to adhere to these dates.",
    "5. Repeated student absence is not allowed, and the school shall not bear any delay or educational loss due to absence, with the exception of medical cases.",
  ],
    financialContractTitle: "Financial Contract",
  financialContract: `
  <h5>First: Contract Terms:</h5>
  <p>The following terms have the meanings indicated below:</p>
  <ul>
    <li>First Party: Al-Afaq Private School.</li>
    <li>Second Party: The student’s guardian.</li>
  </ul>

  <h5>Second: Contract Articles and Clauses:</h5>
  <p>By clicking the approval button below, you acknowledge and agree to the following:</p>
  <ol>
    <li>This contract is the official document that governs the financial relationship between both parties and serves as the main reference in case of any dispute or issue.</li>
    <li>By signing this document, the second party fully acknowledges their responsibility to fulfill all financial obligations outlined in this document.</li>
  </ol>

  <h5>Tuition Fees:</h5>
  <p>Include the following:</p>
  <ul>
    <li>Annual tuition fees, as specified <a href="/expenses"><span style="background-color: #e63967; color: white; padding: 4px 16px; border-radius: 8px; text-decoration: none;">in the following table.</span></a></li>
    <li>Transportation fees.</li>
    <li>Books and nutrition fees.</li>
  </ul>

  <ul>
    <li>The second party must comply with one of the following payment options:</li>
    <ul>
      <li>Pay the annual fees in full (before the end of the first semester).</li>
      <li>Pay the annual fees in two installments (first and second semesters).</li>
      <li>Pay the annual fees in monthly installments.</li>
    </ul>

    <li>If the second party is late in paying the fees beyond the specified date, the first party has the right to demand payment by all available means.</li>
    <li>If the second party delays payment beyond the due date, the first party has the right to demand payment using all available means.</li>
    <li>If the student loses their books or any official document provided by the school, a replacement fee must be paid.</li>
    <li>Student withdrawal after seat reservation is prohibited except in urgent cases such as travel or illness, supported by official proof.</li>
    <li>The seat reservation fee is non-refundable under any circumstances.</li>
    <li>The guardian must pay the full tuition fees if the student withdraws after the start of the school year.</li>
    <li>If payment is delayed for more than three months without agreement, administrative measures will be applied — including suspension of transportation and withholding of certificates.</li>
    <li>In the case of in-person education (as per Ministry Resolution No. 194/2021), the full fees will be collected according to the fee schedule.</li>
    <li>Official holidays are considered part of the school calendar, and tuition fees continue during those days without interruption.</li>
  </ul>
`,

Mission:"Mission",
Objectives:"Objectives",
Values:"Values",
    Lateattendance:"Late attendance",
    present:"Present",
    Absent:"Absent",
Searchbystudentname:"Search by student name",
Transporttype:"Transport type",
  "Doeshesufferfromanyillnesses":"Does he suffer from any illnesses?",
DataEntry:"Data Entry",

filterByGrade:"Filter By Grade",
filterByStage:"Filter By Stage",

VisionContent:"Outstanding, high-quality education that keeps pace with development and technology.",
MissionContent:"Preparing a cultured and creative generation with sound morals, capable of facing the challenges of the age with its authentic Omani character.",
ObjectivesContent: `1. Most students achieve a minimum academic level of "Good" in all subjects.

2. Enhance the efficiency and performance of school staff, particularly in utilizing modern technology and implementing various artificial intelligence applications.

3. Implement the school curriculum in accordance with the vision of developing education to advance society.

4. Involve students' families in supervising and motivating their children's learning and providing a suitable learning environment.

5. Foster a culture of respect and mutual responsibility among all members of the school community.

6. Discover and nurture student talents to serve the community.

7. Cultivate a spirit of citizenship and belonging, and promote the preservation of the nation's achievements.

8. Instill positive values ​​to raise moral standards and improve behavior.`,

ValuesContent:`
1. The student is the focus of the educational process.

2. The teacher is the focus of the educational process and is capable of instilling and nurturing values.

3. Adherence to the Islamic faith and its tolerant and moderate values ​​is the foundation of good citizenship.

4. Student education is a shared process between the school and the family.

5. Cooperation (students, teaching staff, local community).

6. Respect (the student for themselves, the student for their teacher, the school staff, the local community).

7. Community partnership (the school and the family, the school and the local community).
`,
Registrationfile:"Registration File ",
signature: "Signature",
delete: "Delete",
drawSignature: "Draw Signature (below):",
includeSignature: "Include signature in PDF",
downloadSignedPdf: "Download signed PDF",
or: "or",
signAndResend: "Sign the file and resend it",
PickPDF:"Pick PDF",
    priceTotal:"Final price",
FilterBy:"Filter By",
copyRighgt:"All rights reserved to alafaq Schools - Programming and design by ",
contactusPargraph:"Please contact us on the following numbers, or via email",
ourServices:"Our Services",
Leading:"Leading educational and pedagogical features",

  distanceLearningPaymentTitle: "Financial Payment Policy for Distance Learning",
  distanceLearningPayment:[ `
  <ul>
    <li>In the event that education transitions to a distance learning system, the guardian is required to complete the current month and pay its full dues. Withdrawal or continuation is only permitted after the month ends.</li>
    <li>Tuition fee reductions for distance learning, as stated <a href="/expenses"><span style="background-color: #e63967; color: white; padding: 4px 16px; border-radius: 8px; text-decoration: none;">in the tuition schedule</span></a>, will only apply if the decision extends for more than 31 days, excluding official holidays.</li>
    <li>In all cases, advance payment fees, book fees, and meal fees are not subject to any modification or installment.</li>
    <li>If the school determines that the student has learning difficulties, special needs, or other issues, the school reserves the right to terminate the contract while requiring the guardian to pay the registration fee and the tuition for the months already attended.</li>
  </ul>
  `],
    directLearningPaymentTitle: "Financial Payment Policy for In-Person Learning",
  directLearningPayment: [`
  <ul>
    <li>The second party is required to pay all tuition installments in full, from the first month to the last month of the academic year. Fees are not divided based on school days, nor are deductions made for months with fewer days.</li>
    <li>In the event of an exceptional or emergency adjustment by the Ministry of Education to the annual calendar (start or end of the school year only), the institution applies the following rule: if the number of school days in a month is less than 15 days, half of the monthly fee shall be paid; if it equals or exceeds 15 days, the full monthly fee shall be paid.</li>
  </ul>
  `],
  studentregistering:"A student registering for the first time at school",
studyingatschool:"A student studying at school",
  newStudentTitle: "New Student (First-time Enrollment)",
  newStudentDescription: "Before proceeding with registration, please ensure that the following documents are provided:",
  newStudentDocuments: [`
  <ul>
    <li>Guardian’s National ID / Residence Permit</li>
    <li>Student’s Residence Permit (for non-citizen students)</li>
    <li>Student’s personal photo</li>
    <li>Copy of student’s passport (if available)</li>
    <li>Copy of student’s birth certificate</li>
    <li>Copy of student’s health card</li>
  </ul>
  `],
  newStudentSelectGrade: "Please select the academic grade",
  Privatetransportation:"Private transportation",
  Schooltransportation:"School transportation",
  Tracknumber:"Track number",
Housenumber:"House number",
Nearestknownlocation:"Nearest known location",
Linklocation:"Link to the house's location on the map",
Healthcondition:"Health condition",
Pronunciationcorrectness:"Pronunciation correctness",
Needsfollowup:"Needs follow-up",
Verygood:"Very good",
Doesnotread:"Does not read",
PreviousSchoolData:"Previous School Data",
randomlyidentifyletters:"Can he distinguish letters randomly?",
readshortwords:"Can he read short words?",
readshortsentences:"Can he read short sentences?",
surahsfromtheQuran:"Does he memorize any surahs from the Quran?",
Othereducationalnotes:"Other educational notes",
BehavioralData:"Student Behavioral Data",
DistinctiveSkills:"Student's Distinctive Skills",
StudentBehaviors:"Student Behaviors",
Choosebehaviors:"Choose behaviors",
hyperactive:"Hyperactive",
irritable:"Irritable",
inflexible:"Inflexible",
introvert:"Introvert",
shy:"shy",
articulate:"Articulate",
Mothersdata:"Mother's Data",
Mothersname:"Mother's name",
Nationality:"Nationality",
Civilnumber:"Civil number",
Motherphonenumber:"Mother's phone number",
Worklocation:"Work location",
Educationallevel:"Educational level",
parentStatus: "Parents' Status",
relativeName: "Name of a Relative (for emergency contact) ",
relationship: "Relationship",
relativePhone: "Relative's Phone Number",
parentsTogether: "Together",
parentsSeparated: "Separated",
parentsWidower: "Widower",
parentsWidow: "Widow",
search:"Search",

fatherName: "Father's Name ",
fatherNationality: "Nationality ",
fatherCivilId: "Civil ID ",
fatherPhone: "Father's Phone Number ",
fatherJob: "Occupation ",
fatherWorkplace: "Workplace ",
fatherEducationLevel: "Educational Level ",
fatherDataTitle: "Father's Information",
siblingCount: "Number of Siblings ",
siblingOrder: "Order Among Siblings ",
birthDate: "Date of Birth ",
studentDataTitle: "Student's Personal Information",
studentCivilId: "Civil ID ",
studentNameAr: "Full Name (in Arabic) ",
studentNameEn: "Full Name (in English) ",
fatherName: "Father's Name ",
fatherNationality: "Nationality ",
fatherCivilId: "Civil ID ",
fatherPhone: "Father's Phone Number ",
fatherJob: "Occupation ",
fatherWorkplace: "Workplace ",
fatherEducationLevel: "Educational Level ",
forgetPassword:"Forgot your password?",
  FromgradesPostprimary:"(From grades 10 to 12)",
  FromgradesBasic:"(From 1st to 9th grade)",
    "or":"Or",

Good:"Good",
Excellent:"Excellent",
chronicillnesses:"Does he suffer from chronic illnesses?",
particularfood:"Does he have an allergy to a particular food?",
Othernotes:"Other notes",
Other:"Others",
Studenteducationaldata:"Student educational data",
yes:"yes",
No:"No",
studiedbefore:"Has he ever studied before?",

jobTitle:"Job Title"


















































  },
};
